//import axios from "axios";
/**
 * Cambiar de estado las instituciones, socio extranjero y empresas
 */
import ApiService from "@/core/services/api.service";
// action types

export const ACTUALIZAR_ESTADO_ITEM ="actualizarEstadoItem";
// mutation types
export const SET_ESTADO_ITEM = "setEstadoItem";


const state = {
    estados:[],
    estado:[],
}

const getters = {
    obtenerEstadosItem(state) {
      return state.estados;
    },
}

const actions = {
    


    async [ACTUALIZAR_ESTADO_ITEM](context, datos){
        let id = datos.id;
        console.log(datos)
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Compliant/UpdateEstado/`, datos.datosItem)
                .then(({ data }) => {
                    context.commit(SET_ESTADO_ITEM, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

    
  }

const mutations = {
    

    [SET_ESTADO_ITEM](state, data) {
        state.estado = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}